// extracted by mini-css-extract-plugin
module.exports = {"list":"MetadataList_list__3DlqI","textItem":"MetadataList_textItem__KKmMN","linkItem":"MetadataList_linkItem__WRgVv","inline":"MetadataList_inline__jHQLo"};